import { IAdminSlice, TAdminPage } from "@/redux/slices/admin/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { duplicateAdminPage } from "@/lib/api-server/admin/page/duplicateAdminPage";

export const duplicatePage = createAsyncThunk(
  "admin/duplicatePage",
  async (
    {
      uuid,
      storeUuid,
    }: {
      uuid: string;
      storeUuid: string;
    },
    { rejectWithValue }
  ) =>
    await duplicateAdminPage(uuid, storeUuid).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

const rejected = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: false,
      };
    }
    return page;
  });
};

const fulfilled = (
  state: IAdminSlice,
  { payload, meta }: { payload: TAdminPage; meta: { arg: TAdminPage } }
) => {
  state.pages.push(payload);
  state.current_page = payload.uuid;

  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

export default {
  action: duplicatePage,
  pending,
  rejected,
  fulfilled,
};
